<div class="container">
  <div class="share-wrapper">
    <div class="close-icon" (click)="closeModal()">&#10005;</div>
    <h2>Share Website</h2>
    <div class="wrap">
      <p>Do a post on</p>
      <div class="share-options">
        <div
          *ngFor="let app of shareAppsAsPost"
          class="app"
          (click)="share(app)"
        >
          <div [style.background-color]="app.color" class="logo">
            <img [src]="app.logo" alt="logo" />
          </div>
          <p>{{ app.name }}</p>
        </div>
      </div>
    </div>
    <div class="wrap">
      <p>As a message</p>
      <div class="share-options">
        <div
          *ngFor="let app of shareAppsAsMessage"
          class="app"
          (click)="share(app)"
        >
          <div [style.background-color]="app.color" class="logo">
            <img [src]="app.logo" alt="logo" />
          </div>
          <p>{{ app.name }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="qr-wrapper">
    <div class="qr-code">
      <img [src]="qrCodeUrl" alt="QR Code" />
    </div>
    <p class="text">Scan the QR code to access the page link.</p>
    <button class="btn one" (click)="downloadQrCode()">Download QR Code</button>
    <button class="share-btn" (click)="shareWebsite()">Share Website</button>
    <div class="link-container" (click)="copyLink()">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Shareable Link</mat-label>
        <input matInput [value]="currentLink" readonly />
        <button
          mat-icon-button
          matSuffix
          (click)="copyLink()"
          aria-label="Copy Link"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <!-- <div class="button-wrap" align="end"> -->
    <!-- <button class="btn one" (click)="downloadQrCode()"> -->
    <!-- Download QR Code -->
    <!-- </button> -->
    <!-- <button class="btn two" (click)="copyLink()">Copy Link</button> -->
    <!-- </div> -->
  </div>
</div>
